export default {
  user: 'User',
  entity: 'Entity',
  policy: 'Policy',
  system: 'System',
}
